import { SortValue, StatusConfig } from "../types";

export const REFETCH_QUERIES = ["MyEvents", "GetMyEventsStatusCounts"];

export const EVENT_STATUSES: StatusConfig[] = [
  {
    key: "all",
    count: 200,
    active: {
      containerClass: "border border-success bg-success-bg",
      textClass: "text-success",
      badgeClass: "bg-success-light-green text-success",
    },
  },
  {
    key: "drafts",
    count: 100,
    dotColor: "bg-secondary",
    active: {
      containerClass: "border border-secondary bg-background-gray",
      textClass: "text-dark",
      badgeClass: "bg-secondary text-info",
    },
  },
  {
    key: "published",
    count: 0,
    dotColor: "bg-success",
    active: {
      containerClass: "border border-success bg-success-bg",
      textClass: "text-success",
      badgeClass: "bg-success-light-green text-success",
    },
  },
  {
    key: "moderation",
    count: 1,
    dotColor: "bg-amber",
    active: {
      containerClass: "border border-amber bg-warning-light",
      textClass: "text-amber",
      badgeClass: "bg-amber text-white",
    },
  },
  {
    key: "finished",
    count: 0,
    dotColor: "bg-info",
    active: {
      containerClass: "border border-info bg-sec-background-light",
      textClass: "text-info",
      badgeClass: "bg-info text-white",
    },
  },
  {
    key: "needs_changes",
    count: 0,
    dotColor: "bg-danger",
    active: {
      containerClass: "border border-danger bg-danger-light",
      textClass: "text-danger",
      badgeClass: "bg-danger-bg text-danger",
    },
  },
];

export const SORT_OPTIONS = [
  { value: SortValue.Status },
  { value: SortValue.StartDate },
] as const;

export const getStatusFilterI18nKey = (key: string) =>
  key === "needs_changes" ? "rejected" : key;
